import { render, staticRenderFns } from "./LinkBotDrawerActions.vue?vue&type=template&id=2d67830d"
import script from "./LinkBotDrawerActions.vue?vue&type=script&lang=js"
export * from "./LinkBotDrawerActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports